module.exports = __webpack_public_path__ + "img/xmszsqBg.107bf656.png";